import { fetcher } from '@/utils/fetcher'
import useSwr from 'swr'
import { API_URL } from '@/utils/constants'

export default function useProfile(address: string) {
	return useSwr(`${API_URL}/wallet/${address}/profile`, fetcher)
}
